<template>
  <div class="Profile container">
    <div class="Head">
      <span>{{
        $t(
          courseID == null
            ? "pages.adding_course.create"
            : "pages.adding_course.edit"
        )
      }}</span>

      <router-link to="/org/profile" class="btn-back">
        <img src="./../../assets/img/ReDesign/interface_icons/arrow_back.svg" alt=""/>
      </router-link>
    </div>

    <div class="Body">
      <div v-for="(block, bindx) in form" :key="`block-${bindx}`" class="Block">
        <span class="Title">{{ $t(block.title) }}</span>
        <div class="Form">
          <div
            v-for="(fieldblock, fbindx) in block.fields"
            :key="`fieldblock-${fbindx}`"
            class="BlockLine"
          >
            <template v-if="fieldblock.type === 'single'">
              <template v-if="fields[fieldblock.field].type === 'avatar'">
                <div class="Avatar">
                  <div class="AvatarIMG"></div>
                  <div class="AvatarBG"></div>
                </div>

                <span
                  v-if="fields[fieldblock.field].label != null"
                  class="BLLabel"
                  style="font-size: 14px"
                >
                  <span>{{ $t(fields[fieldblock.field]?.label) }}</span>
                  <span
                    v-if="fields[fieldblock.field]?.required === true"
                    :style="`color: ${fields[fieldblock.field]?.req_color}`"
                  >
                    {{ $t(fields[fieldblock.field]?.req_text) }}
                  </span></span
                >
              </template>

              <template v-if="fields[fieldblock.field].type === 'text'">
                <div class="InputWrap">
                  <DefaultInput
                    v-model="fields[fieldblock.field].value"
                    @update:modelStatus="fields[fieldblock.field].validate = $event"
                    :maxLength="fields[fieldblock.field].max_length ? fields[fieldblock.field].max_length : 255"
                    :placeholder="
                      fields[fieldblock.field]?.placeholder
                        ? $t(fields[fieldblock.field]?.placeholder) : ''
                    "
                    :isNull="!fields[fieldblock.field].required"
                    :type="fields[fieldblock.field].only_numbers ? 
                      'number' : 
                      fields[fieldblock.field].only_numbers_with_mask ? 
                      'price' :
                      fields[fieldblock.field].only_float ?
                      'float' :
                      'text'"
                  />
                </div>
              </template>

              <template v-if="fields[fieldblock.field].type === 'textarea'">
                <DefaultTextarea
                  v-model="fields[fieldblock.field].value"
                  @update:modelStatus="fields[fieldblock.field].validate = $event"
                  :placeholder="
                    fields[fieldblock.field]?.placeholder
                      ? $t(fields[fieldblock.field]?.placeholder) : ''
                  "
                  :maxLength="
                    fields[fieldblock.field]?.max_length || ta_max_length
                  "
                  :isNull="!fields[fieldblock.field].required"
                />
              </template>

              <template v-if="fields[fieldblock.field].type === 'btn'">
                <div
                  :class="fields[fieldblock.field].class"
                  @click="formButtonHandler(fieldblock.field)"
                >
                  <img
                    v-if="fields[fieldblock.field]?.need_icon === true"
                    :src="fields[fieldblock.field].icon"
                    alt=""
                  />
                  <span>{{ $t(fields[fieldblock.field].value) }}</span>
                </div>
              </template>

              <template v-if="fields[fieldblock.field].type === 'check'">
                <DefaultCheckbox
                  v-model="fields[fieldblock.field].value"
                  :label="fields[fieldblock.field]?.checklabel ? $t(fields[fieldblock.field].checklabel) : ''"
                />
              </template>

              <template v-if="fields[fieldblock.field].type === 'dateWithTime'">
                <DefaultInput
                  v-model="fields[fieldblock.field].value"
                  @update:modelStatus="fields[fieldblock.field].validate = $event"
                  :placeholder="$t(fields[fieldblock.field].label)"
                  type="datetime"
                  :isNull="!fields[fieldblock.field].required"
                />
              </template>

              <template v-if="fields[fieldblock.field].type === 'switch'">
                <CustomSelect
                  v-model="fields[fieldblock.field].value"
                  :options="switchOptions[fieldblock.field]"
                  :placeholder="
                    `${$t(fields[fieldblock.field]?.placeholder)}${$t(
                      fields[fieldblock.field]?.req_text
                    )}`
                  "
                />
                
              </template>

              <template v-if="fields[fieldblock.field].type === 'fileUpload'">
                <DefaultFileInput
                  v-model="fields[fieldblock.field].value"
                  :uploadUrl="fields[fieldblock.field].loaded"
                  :label="$t(fields[fieldblock.field].label)+'*'"
                />
              </template>

              <template v-if="fields[fieldblock.field].type === 'modules'">
                <div class="Modules">
                  <div
                    class="Module"
                    v-for="(module, index) in courseModulesByOrder"
                    :key="module._id"
                  >
                    <div class="ModuleActions">
                      <div 
                        v-show="index+1 < courseModulesByOrder.length" 
                        class="Action" 
                        @click="changeOrder('down', index, courseModulesByOrder)"
                      >
                        <img
                          src="./../../assets/img/ReDesign/interface_icons/arrow_down_black_16px.svg"
                          alt=""
                        />
                      </div>
                      <div 
                        v-show="index > 0" 
                        class="Action" 
                        @click="changeOrder('up', index, courseModulesByOrder)"
                      >
                        <img
                          style="transform: rotate(180deg);"
                          src="./../../assets/img/ReDesign/interface_icons/arrow_down_black_16px.svg"
                          alt=""
                        />
                      </div>
                      <div 
                        v-show="courseModulesByOrder.length > 1" 
                        class="Action" 
                        @click="deleteElementRecalcOrder(index, courseModulesByOrder)"
                      >
                        <img
                          style="width: 20px; height: 20px"
                          src="./../../assets/img/ReDesign/interface_icons/close_modal_16px.svg"
                          alt=""
                        />
                      </div>
                    </div>
                    <DefaultInput
                      v-model="module.name"
                      @update:modelStatus="module._validate.name = $event"
                      :label="$t(fields[fieldblock.field].label_name)"
                      :isNull="false"
                    />
                    <DefaultTextarea
                      v-model="module.desc"
                      @update:contentRaw="module.descRaw = $event"
                      @update:modelStatus="module._validate.desc = $event"
                      :label="$t(fields[fieldblock.field].label_desc)"
                      :maxLength=3000
                      type="vuequill"
                    />
                  </div>
                  <button
                    class="btn-n-white AddButton"
                    @click="addModule()"
                  >
                    {{ $t(fields[fieldblock.field].button_add) }}
                  </button>
                </div>
              </template>

              <template v-if="fields[fieldblock.field].type === 'teachers'">
                <div class="Modules">
                  <div
                    class="Module"
                    v-for="(teacher, index) in courseTeachersByOrder"
                    :key="teacher._id"
                  >
                    <div class="ModuleActions">
                      <div v-show="index+1 < courseTeachersByOrder.length" class="Action" @click="changeOrder('down', index, courseTeachersByOrder)">
                        <img
                          src="./../../assets/img/ReDesign/interface_icons/arrow_down_black_16px.svg"
                          alt=""
                        />
                      </div>
                      <div v-show="index > 0" class="Action" @click="changeOrder('up', index, courseTeachersByOrder)">
                        <img
                          style="transform: rotate(180deg);"
                          src="./../../assets/img/ReDesign/interface_icons/arrow_down_black_16px.svg"
                          alt=""
                        />
                      </div>
                      <div 
                        v-show="courseTeachersByOrder.length > 1" 
                        class="Action" 
                        @click="deleteElementRecalcOrder(index, courseTeachersByOrder)"
                      >
                        <img
                          style="width: 20px; height: 20px"
                          src="./../../assets/img/ReDesign/interface_icons/close_modal_16px.svg"
                          alt=""
                        />
                      </div>
                    </div>
                    <DefaultFileInput
                      v-model="teacher.avatarDataUrl"
                      :uploadUrl="teacher.avatar"
                      :label="$t(fields[fieldblock.field].label_avatar)"
                      type="avatar"
                    />
                    <DefaultInput
                      v-model="teacher.name"
                      @update:modelStatus="teacher._validate.name = $event"
                      :label="$t(fields[fieldblock.field].label_name)"
                      type="fio"
                      :isNull="false"
                    />
                    <DefaultTextarea
                      v-model="teacher.desc"
                      @update:modelStatus="teacher._validate.desc = $event"
                      :label="$t(fields[fieldblock.field].label_desc)"
                      :maxLength=3000
                    />
                  </div>
                  <button
                    class="btn-n-white AddButton"
                    @click="addTeacher()"
                  >
                    {{ $t(fields[fieldblock.field].button_add) }}
                  </button>
                </div>
              </template>
            </template>

            <template v-if="fieldblock.type === 'line-horizontal-primary'">
              <div
                class="grid-line-elements"
                :style="
                  `grid-template-columns: 264px repeat(${fieldblock.fields
                    .length - 1}, minmax(0,1fr));`
                "
              >
                <div
                  v-for="(_field, _findx) in fieldblock.fields"
                  :key="`_field-${_findx}`"
                  class="BlockLine"
                >
                  <span v-if="fields[_field].label != null" class="BLLabel"
                    >{{ $t(fields[_field]?.label) }}
                    <span
                      v-if="fields[_field]?.required === true"
                      :style="`color: ${fields[_field]?.req_color}`"
                    >
                      {{ $t(fields[_field]?.req_text) }}
                    </span></span
                  >

                  <template v-if="fields[_field].type === 'text'">
                    <input
                      type="text"
                      v-model="fields[_field].value"
                      :placeholder="
                        fields[_field]?.placeholder
                          ? $t(fields[_field]?.placeholder) +
                            ' ' +
                            (fields[_field]?.req_text
                              ? $t(fields[_field]?.req_text)
                              : '')
                          : ''
                      "
                    />
                  </template>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>

      <div class="Buttons">
        <div 
          class="btn-router-link" 
          :class="validateSuccess ? 'btn-n-yellow' : 'btn-n-yellow-disabled'" 
          @click="createOrUpdate"
        >
          <span>
            {{
              $t(
                courseID == null
                  ? "pages.adding_course.buttons.create"
                  : "pages.adding_course.buttons.save"
              )
            }}</span
          >
        </div>

        <router-link to="/org/profile" class="btn-n-white-no-border btn-router-link">
          <span>{{ $t("pages.adding_course.buttons.cancel") }}</span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { transformUrl } from "@/utils/transformUrl.js";
import { mapGetters, mapMutations } from "vuex";
import { findById } from "@/api/user.js";
import { refresh } from "@/api/auth.js";
import { getLangsList } from "@/api/courses_lang.js";
import { getJobByID, createJob, updateJob } from "@/api/job.js";
import { findByAuthorId } from "@/api/n_project.js";
import { dataURLtoFile } from "@/utils/dataURLtoFile.js";

import { ElNotification } from "element-plus";

import DefaultInput from "@/components/OctaUI/Inputs/DefaultInput.vue";
import CustomSelect from "@/components/OctaUI/Selects/CustomSelect.vue";
import DefaultFileInput from "@/components/OctaUI/Inputs/DefaultFileInput.vue";
import DefaultTextarea from "@/components/OctaUI/Inputs/DefaultTextarea.vue";
import DefaultCheckbox from "@/components/OctaUI/Selects/DefaultCheckbox.vue";

import "@/assets/css/Repainting/Buttons.css";

export default {
  components: {
    DefaultInput,
    CustomSelect,
    DefaultFileInput,
    DefaultTextarea,
    DefaultCheckbox
  },  
  data() {
    return {
      fields: {
        name: {
          type: "text",
          value: "",
          placeholder: "pages.adding_course.form.fields.name.placeholder",
          required: true,
          validate: false,
          req_text: "pages.adding_course.form.fields.name.req_text",
          req_color: "#DC3545",
        },
        desc: {
          type: "textarea",
          value: "",
          placeholder: "pages.adding_course.form.fields.desc.placeholder",
          required: false,
          validate: false,
        },
        forWhom: {
          type: "textarea",
          value: "",
          placeholder: "pages.adding_course.form.fields.forWhom.placeholder",
          required: false,
          validate: false,
        },
        newStartDate: {
          type: "dateWithTime",
          value: "",
          error: "",
          label: "pages.adding_course.form.fields.newStartDate.label",
          required: true,
          validate: false,
          req_text: "pages.adding_course.form.fields.newStartDate.req_text",
          req_color: "#DC3545",
        },
        hasTrial: {
          type: "check",
          value: false,
          checklabel: "pages.adding_course.form.fields.hasTrial.checklabel",
          required: false,
          validate: false,
        },
        lang: {
          type: "switch",
          value: null,
          placeholder: "pages.adding_course.form.fields.lang.placeholder",
          required: true,
          validate: false,
          req_text: "*",
          req_color: "#DC3545",
        },
        format: {
          type: "switch",
          value: null,
          placeholder: "pages.adding_course.form.fields.format.placeholder",
          required: true,
          validate: false,
          req_text: "*",
          req_color: "#DC3545",
        },
        // address: {
        //   type: "text",
        //   value: "",
        //   label: "pages.adding_course.form.fields.address.label",
        //   required: true,
        //   validate: false,
        //   req_text: "pages.adding_course.form.fields.address.req_text",
        //   req_color: "#DC3545",
        // },
        courseDuration: {
          type: "text",
          need_mask: true,
          only_float: true,
          max_length: 4,
          value: "",
          placeholder: "pages.adding_course.form.fields.courseDuration.label",
          required: true,
          validate: false,
          req_text: "pages.adding_course.form.fields.courseDuration.req_text",
          req_color: "#DC3545",
        },
        lessonDuration: {
          type: "text",
          need_mask: true,
          only_numbers: true,
          max_length: 4,
          value: "",
          placeholder: "pages.adding_course.form.fields.lessonDuration.label",
          required: true,
          validate: false,
          req_text: "pages.adding_course.form.fields.lessonDuration.req_text",
          req_color: "#DC3545",
        },
        job_modules: {
          type: "modules",
          value: [
            { 
              id: null, name: null, desc: '', descRaw: '', order: 1, courseId: null,
              _validate: {
                name: false,
                desc: false
              },
              _id: Date.now() // Уникальный id для сортировки
            }
          ],
          label_name: "pages.adding_course.form.fields.job_modules.label_name",
          label_desc: "pages.adding_course.form.fields.job_modules.label_desc",
          button_add: "pages.adding_course.form.fields.job_modules.button_add",
          required: true
        },
        course_teachers: {
          type: "teachers",
          value: [
            { 
              id: null, name: null, desc: '', order: 1, courseId: null, avatarDataUrl: null, avatar: null,
              _validate: {
                name: false,
                desc: false
              },
              _id: Date.now() // Уникальный id для сортировки
            }
          ],
          label_avatar: "pages.adding_course.form.fields.course_teachers.label_avatar",
          label_name: "pages.adding_course.form.fields.course_teachers.label_name",
          label_desc: "pages.adding_course.form.fields.course_teachers.label_desc",
          button_add: "pages.adding_course.form.fields.course_teachers.button_add",
          required: true
        },
        homework: {
          type: "check",
          value: false,
          checklabel: "pages.adding_course.form.fields.homework.checklabel",
          required: false,
          validate: false,
        },
        finalExam: {
          type: "check",
          value: false,
          checklabel: "pages.adding_course.form.fields.finalExam.checklabel",
          required: false,
          validate: false,
        },
        price: {
          type: "text",
          value: "",
          only_numbers_with_mask: true,
          max_length: 11,
          placeholder: "pages.adding_course.form.fields.price.label",
          required: true,
          req_text: "pages.adding_course.form.fields.price.req_text",
          req_color: "#DC3545",
          validate: false,
        },
      },

      form: [
        {
          title: "pages.adding_course.form.title",
          fields: [
            {
              type: "single",
              field: "name",
            },
            {
              type: "single",
              field: "desc",
            },
            {
              type: "single",
              field: "forWhom",
            },
            {
              type: "single",
              field: "newStartDate",
            },
            {
              type: "single",
              field: "hasTrial",
            },
          ],
        },

        {
          title: "pages.adding_course.form.title_training",
          fields: [
            {
              type: "single",
              field: "lang",
            },
            {
              type: "single",
              field: "format",
            },
            // {
            //   type: "single",
            //   field: "address",
            // },
            {
              type: "single",
              field: "courseDuration",
            },
            {
              type: "single",
              field: "lessonDuration",
            },
          ],
        },

        {
          title: "pages.adding_course.form.title_program_course",
          fields: [
            {
              type: "single",
              field: "job_modules",
            },
          ],
        },

        {
          title: "pages.adding_course.form.title_teachers",
          fields: [
            {
              type: "single",
              field: "course_teachers",
            },
          ],
        },

        {
          title: "pages.adding_course.form.title_certification",
          fields: [
            {
              type: "single",
              field: "homework",
            },
            {
              type: "single",
              field: "finalExam",
            },
          ],
        },

        {
          title: "pages.adding_course.form.title_payment",
          fields: [
            {
              type: "single",
              field: "price",
            },
          ],
        },
      ],

      format: [
        "tables.jobs.train_format.online",
        "tables.jobs.train_format.offline",
        "tables.jobs.train_format.hybrid",
      ],
      langs: [],

      ta_max_length: 350,

      courseID: null,
      n_projectdID: null,
    };
  },
  computed: {
    ...mapGetters({
      user: "auth/isLoggedIn",
    }),

    // Сортируем модули по Order
    courseModulesByOrder() {
      return this.fields.job_modules.value.sort((a, b) => a.order - b.order);
    },

    // Сортируем учителей по Order
    courseTeachersByOrder() {
      return this.fields.course_teachers.value.sort((a, b) => a.order - b.order);
    },

    validateSuccess() {
      return (
        this.fields.name.validate &&
        this.fields.desc.validate &&
        this.fields.forWhom.validate &&
        this.fields.newStartDate.validate &&
        this.fields.lang.value &&
        this.fields.format.value &&
        this.fields.courseDuration.validate &&
        this.fields.lessonDuration.validate &&
        this.fields.price.validate &&
        this.fields.job_modules.value.every(item => item._validate.name) &&
        this.fields.job_modules.value.every(item => item._validate.desc) &&
        this.fields.course_teachers.value.every(item => item._validate.name) &&
        this.fields.course_teachers.value.every(item => item._validate.desc)
      );
    },

    switchOptions() {
      return {
        format: this.format.map((x) => {
          return {
            name: x,
            value: x,
          };
        }),
        lang: this.langs.map((x) => {
          return {
            name: x.lang,
            value: x.id,
          };
        }),
      };
    },
    maskText() {
      return {
        courseDuration: this.pluralize(this.fields.courseDuration.value, [
          "pages.adding_course.form.pluralize.month[0]",
          "pages.adding_course.form.pluralize.month[1]",
          "pages.adding_course.form.pluralize.month[2]",
        ]),
        lessonDuration: this.pluralize(this.fields.lessonDuration.value, [
          "pages.adding_course.form.pluralize.minute[0]",
          "pages.adding_course.form.pluralize.minute[1]",
          "pages.adding_course.form.pluralize.minute[2]",
        ]),
      };
    },
  },
  async created() {
    try {
      let langsResp = await getLangsList();
      this.langs = langsResp.data;
    } catch (error) {
      console.log(error);
    }

    if (this.user == null) {
      this.updateUser();
    } else {
      this.getUser(this.user.id);
    }

    await this.getCourses();

    try {
      if (
        this.$route.query?.courseID != null &&
        this.$route.query?.courseID != ""
      ) {
        this.courseID = parseInt(this.$route.query?.courseID);
        let JobDataResp = await getJobByID(this.courseID);

        if (this.n_projectdID !== JobDataResp.data.nProjectId) {
          this.$router.push("/org/profile");
          return 0;
        }

        this.fields.name.value = JobDataResp.data.name;
        this.fields.desc.value = JobDataResp.data.description;
        this.fields.forWhom.value = JobDataResp.data.forWhom;
        this.fields.newStartDate.value = this.formatDate(
          JobDataResp.data.dateStart,
          true
        );
        this.fields.hasTrial.value = JobDataResp.data.trialSession;
        this.fields.lang.value = JobDataResp.data.lang;
        this.fields.format.value = JobDataResp.data.trainFormat;
        // this.fields.address.value = JobDataResp.data.address;
        this.fields.courseDuration.value = String(JobDataResp.data.courseDuration);
        this.fields.lessonDuration.value = JobDataResp.data.lessonDuration;
        this.fields.homework.value = JobDataResp.data.homework;
        this.fields.finalExam.value = JobDataResp.data.finalExam;

        this.fields.price.value = new Intl.NumberFormat("ru-RU").format(
          JobDataResp.data.price
        );

        // Получаем массив модулей и добавляем в него validate, если массив пуст, дописываем courseId
        if (JobDataResp.data.job_modules?.length > 0) {
          for(const module of JobDataResp.data.job_modules) {
            module._validate = { name: false, desc: false };
            module._id = Date.now(); // Уникальный id для сортировки
          }
          this.fields.job_modules.value = Array.from(JobDataResp.data.job_modules);
        }
        else {
          this.fields.job_modules.value[0].courseId = this.courseID;
        }

        // Получаем массив модулей и добавляем в него validate, если массив пуст, дописываем courseId
        if (JobDataResp.data.course_teachers?.length > 0) {
          for(const teacher of JobDataResp.data.course_teachers) {
            teacher._validate = { name: false, desc: false };
            teacher._id = Date.now(); // Уникальный id для сортировки
          }
          this.fields.course_teachers.value = Array.from(JobDataResp.data.course_teachers);
        }
        else {
          this.fields.course_teachers.value[0].courseId = this.courseID;
        }
      }
    } catch (e) {
      console.log(e);
    }
  },
  methods: {
    transformLink(url) {
      return transformUrl(url);
    },

    // Меняем местами модули по order
    changeOrder(direct, index, array) {
      // Сохраняем скролл(чтобы не прыгал)
      const scrollY = window.scrollY;

      // Поднимаем модуль вверх на 1 ячейку
      if (direct === 'up') {
        // Если модуль уже и так в самом верху - ничего не делаем
        if (index === 0) return;

        array[index].order--;
        array[index-1].order++;
      }
      // Опускаем модуль вниз на 1 ячейку
      if (direct === 'down') {
        // Если модуль уже и так в самом низу - ничего не делаем
        if (index === array.length - 1) return;

        array[index].order++;
        array[index+1].order--;
      }

      // Восстанавливаем скролл
      this.$nextTick(() => {
        window.scrollTo(0, scrollY);
      });
    },

    // Добавляем модуль в массив
    addModule() {
      this.fields.job_modules.value.push({ 
        id: null, name: null, desc: '', descRaw: '', order: this.fields.job_modules.value.length + 1, courseId: this.courseID,
        _validate: {
          name: false,
          desc: false
        },
        _id: Date.now() // Уникальный id для сортировки
      });
    },

    // Добавляем преподавателя в массив
    addTeacher() {
      this.fields.course_teachers.value.push({ 
        id: null, 
        name: null, 
        desc: '', 
        order: this.fields.course_teachers.value.length + 1, 
        courseId: this.courseID, 
        avatarDataUrl: null,
        avatar: null,
        _validate: {
          name: false,
          desc: false
        },
        _id: Date.now() // Уникальный id для сортировки
      });
    },

    // Удаляем элемент из массива и пересчитываем order
    deleteElementRecalcOrder(index, array) {
      array.splice(index, 1);

      array.forEach((element, index) => {
        element.order = index + 1;
      });
    },

    async getCourses() {
      try {
        let getCompanyCoursesRaw = await findByAuthorId(this.user.id);
        let companyWithCourses = getCompanyCoursesRaw.data;
        this.n_projectdID = companyWithCourses[0].id;
      } catch (e) {}
    },

    async createOrUpdate() {
      try {
        for (let key in this.fields) {
          if (this.fields[key]?.required === true) {
            /*if (
              this.fields[key].value == null ||
              this.fields[key].value === ""
            ) {
              ElNotification({
                title: "Упс!",
                type: "error",
                position: "bottom-right",
                customClass: "ELDefaultNotification",
                message: `Поле "${this.$t(
                  this.fields[key]?.label || this.fields[key]?.placeholder
                )}" не является корректным`,
              });

              return 0;
            }*/

            if (
              this.fields[key].hasOwnProperty("error") &&
              this.fields[key]?.error !== null &&
              this.fields[key]?.error != ""
            ) {
              ElNotification({
                title: "Упс!",
                type: "error",
                position: "bottom-right",
                customClass: "ELDefaultNotification",
                message: `Поле "${this.$t(
                  this.fields[key]?.label || this.fields[key]?.placeholder
                )}" не является корректным`,
              });

              return 0;
            }
          }
        }

        let textData = {
          name: this.fields.name.value,
          description: this.fields.desc.value,
          forWhom: this.fields.forWhom.value,
          dateStart: this.parseDate(this.fields.newStartDate.value, true),
          trialSession: this.fields.hasTrial.value,
          lang: this.fields.lang.value,
          trainFormat: this.fields.format.value,
          // address: this.fields.address.value,
          address: "",
          courseDuration: Number(this.fields.courseDuration.value),
          lessonDuration: this.fields.lessonDuration.value,
          homework: this.fields.homework.value,
          finalExam: this.fields.finalExam.value,
          price: this.fields.price.value.replace(/\s/g, ''),
          nProjectId: this.n_projectdID,
          job_modules: this.fields.job_modules.value,
          course_teachers: this.fields.course_teachers.value,
        };

        if (this.courseID != null) {
          textData["id"] = this.courseID;
        }

        let formData = new FormData();
        formData.append("req_data", JSON.stringify(textData));

        for (const teacher of this.fields.course_teachers.value) {
          const file = dataURLtoFile(teacher.avatarDataUrl, "avatar_teacher.png");
          formData.append(
            `course_teachers_avatars[${teacher.order-1}]`,
            file
          );
        }

        if (this.courseID != null) {
          await updateJob(this.courseID, formData);
        } else {
          await createJob(formData);
        }

        this.$router.push("/org/profile");
      } catch (e) {
        console.log(e);
        ElNotification({
          title: "Упс!",
          type: "error",
          position: "bottom-right",
          customClass: "ELDefaultNotification",
          message: this.$t("pages.adding_course.msg.error.server"),
        });
      }
    },

    parseDate(dateString, useUTC = false) {
      // ожидаем формат "дд.мм.гггг чч:мм"
      const [datePart, timePart] = dateString.split(" ");
      const [day, month, year] = datePart.split(".").map(Number);
      const [hours, minutes] = timePart.split(":").map(Number);

      let date;

      if (useUTC) {
        // создаём дату как UTC
        date = new Date(Date.UTC(year, month - 1, day, hours, minutes));
      } else {
        // создаём дату как локальную
        date = new Date(year, month - 1, day, hours, minutes);
      }

      return date.toISOString(); // всегда возвращаем ISO в UTC
    },

    onlyNumbers(event, fieldName) {
      let value = event.target.value.replace(/\D/g, ""); // только цифры
      value = value.replace(/^0+/, ""); // без нулей в начале
      this.fields[fieldName].value = value;
    },

    onlyNumbersWithMask(event, fieldName) {
      let value = event.target.value.replace(/\D/g, ""); // только цифры
      value = value.replace(/^0+/, ""); // без нулей в начале
      const formatted = new Intl.NumberFormat("ru-RU").format(value);
      this.fields[fieldName].value = formatted;
    },

    formatDate(isoString, useUTC = false) {
      const date = new Date(isoString);

      const get = (method) =>
        String(
          useUTC ? date[`getUTC${method}`]() : date[`get${method}`]()
        ).padStart(2, "0");

      const day = get("Date");
      const month =
        get("Month") === "00"
          ? "01"
          : String(
              (useUTC ? date.getUTCMonth() : date.getMonth()) + 1
            ).padStart(2, "0");
      const year = useUTC ? date.getUTCFullYear() : date.getFullYear();
      const hours = get("Hours");
      const minutes = get("Minutes");

      return `${day}.${month}.${year} ${hours}:${minutes}`;
    },

    pluralize(n, textArr) {
      const number = Number(n);
      const mod10 = number % 10;
      const mod100 = number % 100;

      if (mod10 === 1 && mod100 !== 11) {
        return textArr[0];
      } else if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) {
        return textArr[1];
      } else {
        return textArr[2];
      }
    },

    onFileChange(event, fieldName) {
      const file = event.target.files[0];
      if (file) {
        this.fields[fieldName].value = file;
      }
    },

    ...mapMutations("auth", ["SET_USER"]),
    async updateUser() {
      const response = await refresh();
      const userResponse = response.user;
      this.getUser(userResponse.id);
    },
    getUser(id) {
      if (id != undefined) {
        findById(id).then((response) => {
          this.SET_USER(response.data);
        });
      }
    },

    formButtonHandler(fieldName) {
      switch (fieldName) {
        case "btn_add_link": {
          return;
        }
      }
    },

    validateDateTime() {
      if (!this.fields.newStartDate.value) {
        this.fields.newStartDate.error = "pages.adding_course.msg.error.date";
        return;
      }

      const regex = /^(\d{2})\.(\d{2})\.(\d{4}) (\d{2}):(\d{2})$/;
      const match = this.fields.newStartDate.value.match(regex);

      if (!match) {
        this.fields.newStartDate.error = "pages.adding_course.msg.error.format";
        return;
      }

      const day = parseInt(match[1], 10);
      const month = parseInt(match[2], 10);
      const year = parseInt(match[3], 10);
      const hours = parseInt(match[4], 10);
      const minutes = parseInt(match[5], 10);

      if (month < 1 || month > 12) {
        this.fields.newStartDate.error = "pages.adding_course.msg.error.month";
        return;
      }

      const daysInMonth = new Date(year, month, 0).getDate();
      if (day < 1 || day > daysInMonth) {
        this.fields.newStartDate.error =
          $t("pages.adding_course.msg.error.days_in_month[0]") +
          ` ${month} ${year} ` +
          $t("pages.adding_course.msg.error.days_in_month[1]") +
          ` ${daysInMonth} ` +
          $t("pages.adding_course.msg.error.days_in_month[2]");
        return;
      }

      if (hours < 0 || hours > 23) {
        this.fields.newStartDate.error = "pages.adding_course.msg.error.hour";
        return;
      }

      if (minutes < 0 || minutes > 59) {
        this.fields.newStartDate.error = "pages.adding_course.msg.error.minute";
        return;
      }

      this.fields.newStartDate.error = ""; // Всё корректно ✅
    },
  },
};
</script>

<style scoped>
.TextDateMask {
  position: relative;
  display: block;

  width: fit-content;
  height: fit-content;

  font-family: "Involve";
  font-size: 14px;
}

.uploadedFile {
  position: relative;
  display: block;

  margin-top: 10px;

  width: fit-content;
  height: fit-content;

  font-family: "Involve";
  font-size: 14px;
  text-decoration: underline;

  color: #000;
}

.container {
  width: 100%;
  max-width: 1168px; /* 1128px content + 20px padding on each side */
  margin-left: auto;
  margin-right: auto;
  padding-left: 20px;
  padding-right: 20px;
}

.Profile {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: column;
  justify-content: flex-start;
  gap: 50px;
}

.Head {
  position: relative;
  display: inline;

  width: fit-content;
  max-width: 100%;

  height: fit-content;

  font-family: "Involve";
  font-weight: 600;
  font-size: 32px;
  line-height: 130%;
  letter-spacing: 0%;

  color: #1a1a1a;
}
.Body {
  position: relative;
  display: flex;

  width: 100%;
  max-width: 648px;

  flex-direction: column;
  justify-content: flex-start;
  gap: 40px;
}

.Block {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: column;
  justify-content: flex-start;
  gap: 24px;
}
.Title {
  position: relative;
  display: inline;

  width: fit-content;
  max-width: 100%;

  height: fit-content;

  font-family: "Involve";
  font-weight: 500;
  font-size: 20px;
  line-height: 130%;
  letter-spacing: 0%;

  color: #1a1a1a;
}
.Form {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: column;
  justify-content: flex-start;
  gap: 16px;
}

.BlockLine {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: column;
  justify-content: flex-start;
  gap: 0px;
}

.BlockLine .Modules {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: column;
  justify-content: flex-start;
  gap: 16px;
}
.Modules .Module {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: column;
  gap: 16px;
}
.Module .ModuleActions {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: row;
  gap: 4px;
}
.ModuleActions .Action {
  position: relative;
  display: flex;

  width: 32px;
  height: 32px;

  box-shadow: 0px 16px 32px -4px rgba(12, 12, 13, 0.1), 0px 4px 4px -4px rgba(12, 12, 13, 0.05);
  border-radius: 8px;

  align-items: center;
  justify-content: center;

  cursor: pointer;
  user-select: none;

  background: #FFFFFF;
  transition: 0.3s;
}
.ModuleActions .Action:hover {
  transition: 0.3s;
  background: #F8F8F8;
}
.ModuleActions .Action:active {
  transition: 0.3s;
  background: #FFFFFF;
}
.ModuleActions .Action img {
  width: 24px;
  height: 24px;
}

input[type="text"]::placeholder {
  font-family: "Involve";
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: 0%;

  color: #666666;
}
input[type="text"] {
  position: relative;
  display: block;

  outline: none;

  padding: 15.5px 16px;

  width: 100%;
  height: fit-content;

  font-family: "Involve";
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0%;

  color: #1a1a1a;
  background-color: transparent;
  border: 1px solid #666666;

  border-radius: 8px;
}

textarea::placeholder {
  font-family: "Involve";
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: 0%;

  color: #666666;
}
textarea {
  position: relative;
  display: block;

  outline: none;

  padding: 20px 16px;

  width: 100%;

  min-height: 195px;
  height: fit-content;

  font-family: "Involve";
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0%;

  color: #1a1a1a;
  background-color: transparent;
  border: 1px solid #666666;

  border-radius: 8px;

  resize: vertical;
}

.BLLabel > * {
  margin: auto 0%;
}
.BLLabel {
  position: relative;
  display: flex;

  margin-left: 16px;

  width: fit-content;
  max-width: 100%;

  height: fit-content;

  flex-direction: row;
  justify-content: flex-start;
  gap: 4px;

  font-family: "Involve";
  font-weight: 500;
  font-size: 12px;
  line-height: 150%;
  letter-spacing: 0%;

  color: #666666;
}
.TextAreaAvailableSymbols {
  position: relative;
  display: inline;

  margin-left: 16px;

  width: fit-content;
  max-width: 100%;

  height: fit-content;

  font-family: "Involve";
  font-weight: 500;
  font-size: 12px;
  line-height: 150%;
  letter-spacing: 0%;
  color: #666666;
}
.grid-line-elements {
  position: relative;
  display: grid;

  width: 100%;
  height: fit-content;

  gap: 8px;
}
.Avatar {
  position: relative;
  display: block;

  cursor: pointer;

  margin-left: 16px;
  margin-bottom: 4px;

  width: 56px;
  height: 56px;

  border-radius: 100%;
  overflow: hidden;
}
.AvatarBG {
  position: absolute;
  display: block;

  inset: 0;

  width: 100%;
  height: 100%;

  background-color: #f8f8f8;

  z-index: 1;
}
.AvatarIMG {
  position: absolute;
  display: block;

  inset: 0;

  width: 100%;
  height: 100%;

  background: url("./../../assets/img/ReDesign/interface_icons/UserDefaultAvatar.svg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: 24px;

  z-index: 2;
}

.Buttons {
  position: relative;
  display: flex;

  width: fit-content;
  max-width: 100%;

  height: fit-content;

  flex-direction: row;
  justify-content: flex-start;
  gap: 8px;
}
.btn > * {
  margin: auto 0%;
}
.btn {
  position: relative;
  display: flex;

  cursor: pointer;

  padding: 12px 20px;

  width: fit-content;
  height: fit-content;

  flex-direction: row;
  justify-content: flex-start;
  gap: 10px;

  font-family: "Involve";
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0%;
  text-align: center;
  text-decoration: none;

  color: #1a1a1a;
  background-color: transparent;

  border-radius: 8px;
}
.btn.yellow {
  background-color: #f9d773e5;
}

.btn-back {
  position: absolute;
  display: flex;

  width: 48px;
  height: 48px;

  top: 50%;
  left: 0;
  left: -24px;
  transform: translateX(-100%) translateY(-50%);

  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 8px;
  cursor: pointer;

  background: #FFFFFF;

  box-shadow: 0px 16px 32px -4px rgba(12, 12, 13, 0.1), 0px 4px 4px -4px rgba(12, 12, 13, 0.05);
  border-radius: 8px;
  transition: 0.3s;
}
.btn-back:hover {
  transition: 0.3s;
  background: #F8F8F8;
}

.CheckStyled > * {
  margin: auto 0%;
}
.CheckStyled {
  position: relative;
  display: flex;

  flex-direction: row-reverse;
  justify-content: flex-start;
  gap: 4px;

  width: fit-content;
  height: fit-content;
}
.checklabel {
  position: relative;
  display: inline;

  width: fit-content;
  height: fit-content;

  font-family: "Involve";
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0%;

  color: #1a1a1a;
}

/* Скрываем стандартный input */
.checkbox input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Контейнер */
.checkbox {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
}

/* Базовый вид чекбокса */
.checkmark {
  width: 16px;
  height: 16px;
  border-radius: 4px;
  border: 2px solid #ccc; /* цвет рамки */
  display: inline-block;
  position: relative;
  transition: all 0.2s ease;
}

/* Состояние: checked */
.checkbox input:checked + .checkmark {
  background-color: #ffd873; /* жёлтый фон */
  border-color: #ffd873;
}

/* Галочка */
.checkbox input:checked + .checkmark::after {
  content: "";
  position: absolute;
  left: 4px;
  top: 1px;
  width: 5px;
  height: 9px;
  border: solid black;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.InputWrap {
  position: relative;
  width: 100%;
  height: fit-content;
}
.InputWrap > input {
  padding-right: 100px;
}

.InputMaskLabel {
  position: absolute;

  right: 0;
  top: 50%;

  transform: translateY(-50%);
  padding-right: 16px;

  font-family: "Involve";
  font-size: 16px;
}
.Buttons > .btn-router-link {
  width: fit-content;
  height: 48px; 
  font-size: 16px; 
  padding: 8px 16px;
}
.AddButton {
  width: fit-content;
  min-height: 48px;
  height: fit-content;

  padding: 12px 20px;
}
</style>

<style scoped>
@media (max-width: 480px) {
}
@media (min-width: 480px) and (max-width: 768px) {
}
@media (min-width: 768px) and (max-width: 992px) {
}
@media (min-width: 992px) and (max-width: 1400px) {
}
@media (min-width: 1400px) and (max-width: 1600px) {
}
@media (min-width: 1600px) {
}

@media (max-width: 768px) {
  .Buttons {
    width: 100%;
    flex-direction: column;
  }
  .Buttons > .btn-router-link {
    width: 100%;
  }
  .Buttons > .btn > span {
    margin: 0% auto;
  }

  .BLLabel {
    display: inline;
  }

  .checklabel {
    line-height: 110%;
  }

  .BLLabel > span:nth-child(2) {
    padding-left: 4px;
  }

  .InputMaskLabel {
    transform: translateY(-50%);
    padding-right: 16px;
    font-family: "Involve";
    font-size: 12px;
  }
}
</style>
